import script from "./VODFolderManage.vue?vue&type=script&setup=true&lang=js"
export * from "./VODFolderManage.vue?vue&type=script&setup=true&lang=js"

import "./VODFolderManage.vue?vue&type=style&index=0&id=097bb5a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-097bb5a8"]])

export default __exports__